// Why the server ended a board session, told apart by the jwt's own expiry.

import { msg, type Msg } from '../../i18n/msg.ts';

export type SignOutReason = 'revoked' | 'expired';

export function signOutMessage(reason: SignOutReason): Msg {
  return msg(`errors:signOut.${reason}`);
}

/** The `exp` claim in ms, or null when the token carries none or is unreadable. */
export function jwtExpiresAt(jwt: string): number | null {
  const part = jwt.split('.')[1];
  if (!part) return null;
  try {
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '===='.slice(0, (4 - (base64.length % 4)) % 4);
    const claims = JSON.parse(atob(padded)) as { exp?: unknown };
    return typeof claims.exp === 'number' ? claims.exp * 1000 : null;
  } catch (e) {
    return null;
  }
}

// A rejected token still inside its lifetime was cut off by the server, which for a board means the teacher's phone.
export function rejectedSessionReason(jwt: string | null, now: number): SignOutReason {
  const expiresAt = jwt ? jwtExpiresAt(jwt) : null;
  return expiresAt !== null && expiresAt <= now ? 'expired' : 'revoked';
}
